import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormLabel,
  useTheme,
} from '@mui/material';

interface AddPlotGroupModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string, isPrivate: boolean) => void;
}

const AddPlotGroupModal: React.FC<AddPlotGroupModalProps> = ({ open, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [isPublic, setIsPublic] = useState(false);
  const theme = useTheme();  // Use the theme for consistent coloring

  const handleSave = () => {
    onSave(name, isPublic);
    onClose(); // Close the modal after save
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Add Plot Group</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Plot Group Name"
          type="text"
          fullWidth
          variant="outlined"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
        <FormControl component="fieldset" style={{ marginTop: '5px', marginLeft: '5px'}}> 
          <FormControlLabel
            control={
              <Checkbox
                checked={isPublic}
                onChange={(event) => setIsPublic(event.target.checked)}
                color="default"  // Sets the checkbox to the default color, typically grey
              />
            }
            label={<span style={{ color: theme.palette.text.secondary }}>Public</span>}  // Grey color for the label
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPlotGroupModal;
